module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p +=
((__t = ( i18next.t('ui.initial_loading.main') )) == null ? '' : __t) +
'\n<br>\n<br>\n' +
((__t = ( i18next.t('ui.initial_loading.second') )) == null ? '' : __t) +
'\n';

}
return __p
}